import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgV2Settings = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "3px",
	height: "15px",
	viewBox: "0 0 3 15",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "dib_checklists_new-concpet",
			transform: "translate(-383.000000, -92.000000)",
			fill: "currentColor",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "More",
				transform: "translate(383.000000, 92.000000)",
				children: [
					/* @__PURE__ */ _jsx("circle", {
						id: "Oval",
						cx: 1.5,
						cy: 1.5,
						r: 1.5
					}),
					/* @__PURE__ */ _jsx("circle", {
						id: "Oval",
						cx: 1.5,
						cy: 7.5,
						r: 1.5
					}),
					/* @__PURE__ */ _jsx("circle", {
						id: "Oval",
						cx: 1.5,
						cy: 13.5,
						r: 1.5
					})
				]
			})
		})
	})
});
export default SvgV2Settings;
